import { Link } from 'react-router';
import { SetPasswordForm, tokenFromSearch } from './SetPasswordForm';

/**
 * Public page the password-reset mail links to: `/login/reset?token=…`.
 * Same token kind and confirm endpoint as the invite (HUB-106 D1), so the
 * same form; a dead link points the user back at the request page.
 */
export const RESET_EXPIRED_MESSAGE = 'This link is no longer valid.';

export function ResetPassword({ token }: { token: string | null }) {
  return (
    <SetPasswordForm
      token={token}
      title="Choose a new password"
      submitLabel="Set password and sign in"
      expiredMessage={RESET_EXPIRED_MESSAGE}
      expiredAction={
        <p className="text-sm">
          <Link to="/login/forgot" className="underline underline-offset-4">
            Request a new one
          </Link>
        </p>
      }
    />
  );
}

/** Route element: reads the token from the current URL. */
export function ResetPasswordPage() {
  return <ResetPassword token={tokenFromSearch(typeof window === 'undefined' ? '' : window.location.search)} />;
}
